<template>
  <div class="container">
    <!-- <div class="header">
      <h1>扫一扫</h1>
      <button id="togglePanel">
        <i class="fas fa-chart-line"></i> 清晰度
      </button>
    </div> -->

    <div class="camera-container">
      <video id="video" autoplay playsinline></video>

      <div class="scan-overlay">
        <div class="scan-frame">
          <div class="scan-frame-inner"></div>
          <div class="scan-line"></div>
        </div>
        <div class="scan-tips">
          将二维码放入框内，即可自动扫描
        </div>
      </div>

      <div class="loading" id="loading">
        正在初始化摄像头...
      </div>

      <div class="status-panel" id="statusPanel">
        <div class="clarity-info">
          <div class="clarity-icon">
            <i class="fas fa-camera"></i>
          </div>
          <div class="clarity-text">
            图像清晰度
          </div>
          <div class="clarity-value" id="clarityValue">--</div>
        </div>
        <div class="clarity-suggestions" id="claritySuggestions">
          正在检测...
        </div>
      </div>

      <div class="result-panel" id="resultPanel">
        <div class="result-content">
          <div class="result-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="result-text" id="resultText"></div>
          <img src="" alt="" id="resultImg">
          <div class="result-actions">
            <button class="result-btn" id="copyResult">复制</button>
            <button class="result-btn secondary" id="closeResult">继续扫描</button>
          </div>
        </div>
      </div>
    </div>

    <div class="action-bar">
      <button class="action-btn" id="toggleTorch">
        <i class="fas" :class="!isTorchOn ? 'fa1-bolt' : 'fa1-bolt-close'"></i>
        {{ !isTorchOn ? '轻触照亮' : '轻触关闭' }}
      </button>
      <!-- <button class="action-btn" id="switchCamera">
        <i class="fas fa-sync-alt"></i>
        切换摄像头
      </button>
      <button class="action-btn" id="uploadImage">
        <i class="fas fa-image"></i>
        从相册选择
      </button> -->
    </div>
  </div>
</template>
<script>
import { listH5Pages } from '@/api/h5Pages'
import { getH5Applet } from '@/api/h5Applet'
import { getDatabaseIsExits, listKHttpCode } from '@/api/kHttpCode'
import axios from 'axios'
export default {
  data() {
    return {
      targetPoint: { left: 195, top: 195, bottom: 195, width: 500, height: 510 },
      comparisonTool: null,
      // DOM元素
      video: null, //('video');
      loading: null, //('loading');
      statusPanel: null, //('statusPanel');
      clarityValue: null, //('clarityValue');
      claritySuggestions: null, //('claritySuggestions');
      resultPanel: null, //('resultPanel');
      resultText: null, //('resultText');
      copyResultBtn: null, //('copyResult');
      closeResultBtn: null, //('closeResult');
      togglePanelBtn: null, //('togglePanel');
      toggleTorchBtn: null, //('toggleTorch');
      switchCameraBtn: null, //('switchCamera');
      uploadImageBtn: null, //('uploadImage');
      resultImg: null,
      // 状态变量
      mediaStream: null,
      isBackCamera: true,
      isTorchOn: false,
      scanInterval: null,
      clarityCheckInterval: null,
      lastScanResult: null,
      canvas: null,
      ctx: null,

      webpathz: 'http://b.kesiyuan.com',
      scanTip: false,
      model: -1,//识别二维码模式（11：直接跳转二维码路径，12:识别到后走人工客服）
      downTotal: 20,//人工客服响应时间，
      fenBu: false,//是否停止人工客服,
      applet: {
        pages: [],
        obj: {}
      },
      mimc: {
        mimc_appId: '2882303761517644081',
        mimc_appSecret: 'RWm2RxELBLPJmP7+6ESl1Q==',
        mimc_appKey: '5881764490081',
        mimc_appAccount: '',
        mimc_inter: false,
        user: {}

      },
      customerServiceObj: {
        customerServices: [],
        isXWOrWL: 0,
      }
    }
  },
  created() {
    this.$store.commit('SET_JudgeResult', 'xxxx')
    this.model = this.$route.query.model
    this.applet.appletId = this.$route.query.appletId
    var index = new Date().getMilliseconds();
    this.mimc.mimc_appAccount = Math.random().toString(36).substr(2, 8)// TEMPUSERS[index]
    axios.get('/WeCat/login/getloginUser').then(({ data, status }) => {
      this.customerServiceObj.customerServices = data.data
      this.login()
    })
    listH5Pages({ appletId: this.applet.appletId }).then(res => {
      this.applet.pages = res.data
    })

    getH5Applet(this.applet.appletId).then((res) => {
      this.applet.obj = res.data
    })
  },
  mounted() {
    // DOM元素
    this.video = document.getElementById('video');
    this.loading = document.getElementById('loading');
    this.statusPanel = document.getElementById('statusPanel');
    this.clarityValue = document.getElementById('clarityValue');
    this.claritySuggestions = document.getElementById('claritySuggestions');
    this.resultPanel = document.getElementById('resultPanel');
    this.resultText = document.getElementById('resultText');
    this.copyResultBtn = document.getElementById('copyResult');
    this.closeResultBtn = document.getElementById('closeResult');
    this.togglePanelBtn = document.getElementById('togglePanel');
    this.toggleTorchBtn = document.getElementById('toggleTorch');
    this.switchCameraBtn = document.getElementById('switchCamera');
    this.uploadImageBtn = document.getElementById('uploadImage');
    this.resultImg = document.getElementById('resultImg')

    // const cv = window.cv;
    // // 创建图像对比工具实例
    // this.comparisonTool = new ImageComparisonTool(cv);
    this.init()

    setTimeout(() => {
      this.scanTip = true
      // weui.alert('请求超时，请重新验证')
    }, 5000)
  },
  destoryed() {
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => track.stop());
    }
    if (this.scanInterval) clearInterval(this.scanInterval);
    if (this.clarityCheckInterval) clearInterval(clarityCheckInterval);
  },
  methods: {
    opencvInit() {
      // setTimeout(() => {
      //   if (window.cv) {
      //     const cv = window.cv;
      //     // 创建图像对比工具实例
      //     this.comparisonTool = new ImageComparisonTool(cv);
      //     this.startScanning()
      //   } else {
      //     this.opencvInit()
      //   }
      // }, 500);
      this.startScanning()
    },
    async processComparison(capturedImage, url) {
      const uploadedImage = await this.loadImageFromUrl(url)
      const result = await this.comparisonTool.processComparison(
        uploadedImage,
        capturedImage,
        20
      );
      // console.log(JSON.stringify(result))
      return result
    },
    loadImageFromUrl(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();

        // 如果需要跨域访问，设置crossOrigin
        img.crossOrigin = "anonymous";

        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`无法加载图片: ${url}`));

        img.src = url;
      });
    },
    stopCamera() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
      }
      if (this.scanInterval) clearInterval(this.scanInterval);
      if (this.clarityCheckInterval) clearInterval(this.clarityCheckInterval);
    },
    async init() {
      // 创建隐藏的画布用于图像处理
      this.canvas = document.createElement('canvas');
      this.ctx = this.canvas.getContext('2d');

      // 请求摄像头权限并开始视频流
      try {
        const constraints = {
          video: {
            facingMode: this.isBackCamera ? 'environment' : 'user',
            width: { ideal: 1280 },
            height: { ideal: 720 }
          }
        };

        this.mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
        this.video.srcObject = this.mediaStream;

        // 视频加载完成后开始扫描
        this.video.onloadedmetadata = () => {
          this.loading.style.display = 'none';
          this.opencvInit()
          // this.startScanning();
          setTimeout(() => {
            this.startClarityCheck();
          }, 5000);

        };
      } catch (error) {
        this.loading.innerHTML = '无法访问摄像头，请确保已授予摄像头权限';
        console.error('摄像头访问错误:', error);
      }

      // 事件监听
      // this.togglePanelBtn.addEventListener('click', () => {
      //   statusPanel.classList.toggle('show');
      // });

      this.toggleTorchBtn.addEventListener('click', this.toggleTorch);
      // this.switchCameraBtn.addEventListener('click', this.switchCamera);
      // this.uploadImageBtn.addEventListener('click', this.uploadImage);
      // this.copyResultBtn.addEventListener('click', this.copyResult);
      this.closeResultBtn.addEventListener('click', () => {
        this.resultPanel.classList.remove('show');
        this.opencvInit()
        // this.startScanning();
      });
    },

    // 开始扫描
    startScanning() {
      if (this.scanInterval) clearInterval(this.scanInterval);

      this.scanInterval = setInterval(() => {
        if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
          this.captureAndScan();
        }
      }, 500); // 每500ms扫描一次
    },

    // 捕获并扫描图像
    async captureAndScan() {
      // 设置画布尺寸为视频尺寸
      this.canvas.width = this.video.videoWidth;
      this.canvas.height = this.video.videoHeight;

      // 绘制整个视频帧到画布
      this.ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

      // 计算扫描框在画布中的位置（屏幕中央区域）
      const scanBoxSize = 280; // 扫描框大小
      const scaleFactor = this.canvas.width / this.video.clientWidth;
      const scanBoxScaled = scanBoxSize * scaleFactor;

      const x = (this.canvas.width - scanBoxScaled) / 2;
      const y = (this.canvas.height - scanBoxScaled) / 2;

      // 获取扫描框区域的图像数据
      const imageData = this.ctx.getImageData(x, y, scanBoxScaled, scanBoxScaled);

      // 使用jsQR库识别二维码
      const code = jsQR(imageData.data, imageData.width, imageData.height);

      if (code) {

        if (code.location.topRightCorner.x - code.location.topLeftCorner.x < 80) {
          this.updateClarityUI(20)
          return
        }
        // 找到二维码，停止扫描并显示结果
        clearInterval(this.scanInterval);
        this.showResult(code.data);
        this.lastScanResult = code.data;

        if (this.model == 1) { //识别到二维码直接跳转
          location.href = code.data
        } else if (this.model == 2) { //纤维人工识别
          // 保存Canvas和图像数据用于上传
          this.capturedCanvas = this.canvas;

          this.capturedImageData = imageData;
          // console.log(imageData,this.canvas)
          // this.resultImg.src = imageData
          let imgSrc = await this.uploadImage(code.data, code)

        }

      }
    },

    // 开始清晰度检测
    startClarityCheck() {
      if (this.clarityCheckInterval) clearInterval(this.clarityCheckInterval);

      this.clarityCheckInterval = setInterval(() => {
        if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
          this.checkImageClarity();
        }
      }, 1000); // 每1秒检测一次清晰度
    },

    // 检查图像清晰度
    checkImageClarity() {
      // 设置画布尺寸为视频尺寸
      this.canvas.width = this.video.videoWidth;
      this.canvas.height = this.video.videoHeight;

      // 绘制视频帧到画布
      this.ctx.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

      // 计算扫描框在画布中的位置
      const scanBoxSize = 280;
      const scaleFactor = this.canvas.width / this.video.clientWidth;
      const scanBoxScaled = scanBoxSize * scaleFactor;

      const x = (this.canvas.width - scanBoxScaled) / 2;
      const y = (this.canvas.height - scanBoxScaled) / 2;

      // 获取扫描框区域的图像数据
      const imageData = this.ctx.getImageData(x, y, scanBoxScaled, scanBoxScaled);

      // 计算清晰度（使用拉普拉斯方差法）
      const clarity = this.calculateClarity(imageData);

      // 更新UI
      this.updateClarityUI(clarity);
    },

    // 计算图像清晰度（拉普拉斯方差法）
    calculateClarity(imageData) {
      const width = imageData.width;
      const height = imageData.height;
      const data = imageData.data;

      let total = 0;

      // 转换为灰度图像
      const grayData = new Array(width * height);
      for (let i = 0; i < width * height; i++) {
        const r = data[i * 4];
        const g = data[i * 4 + 1];
        const b = data[i * 4 + 2];
        grayData[i] = 0.299 * r + 0.587 * g + 0.114 * b;
      }

      // 计算拉普拉斯方差
      for (let y = 1; y < height - 1; y++) {
        for (let x = 1; x < width - 1; x++) {
          const index = y * width + x;
          const laplace = Math.abs(
            4 * grayData[index] -
            grayData[index - 1] -
            grayData[index + 1] -
            grayData[index - width] -
            grayData[index + width]
          );
          total += laplace;
        }
      }

      // 计算平均值并归一化
      const avg = total / ((width - 2) * (height - 2));

      // 将清晰度归一化到0-100范围
      // 注意：这个值不是绝对的，需要根据实际情况调整阈值
      const normalized = Math.min(100, Math.max(0, avg / 5));

      return Math.round(normalized);
    },

    // 更新清晰度UI
    updateClarityUI(clarity) {
      this.clarityValue.textContent = `${clarity}%`;

      // 根据清晰度值设置颜色和提示
      let clarityClass, suggestion;

      if (clarity >= 70) {
        clarityClass = 'clarity-good';
        suggestion = '图像清晰，可以正常扫描';
      } else if (clarity >= 40) {
        clarityClass = 'clarity-average';
        suggestion = '图像稍模糊，请保持手机稳定';
      } else {
        clarityClass = 'clarity-poor';
        suggestion = '图像模糊，请调整距离或光线';
      }

      this.clarityValue.className = `clarity-value ${clarityClass}`;
      this.claritySuggestions.textContent = suggestion;

      // 如果清晰度太低，自动显示提示面板
      if (clarity < 30 && !this.statusPanel.classList.contains('show')) {
        this.statusPanel.classList.add('show');
      }
    },

    // 显示扫描结果
    showResult(result) {
      this.resultText.textContent = result;
      // this.resultPanel.classList.add('show');
    },

    // 复制结果
    copyResult() {
      navigator.clipboard.writeText(this.lastScanResult)
        .then(() => {
          alert('已复制到剪贴板');
        })
        .catch(err => {
          console.error('复制失败:', err);
          alert('复制失败，请手动选择复制');
        });
    },

    // 切换闪光灯
    toggleTorch() {
      if (!this.mediaStream) return;

      const track = this.mediaStream.getVideoTracks()[0];
      if (typeof track.getCapabilities === 'function') {
        const capabilities = track.getCapabilities();
        if (capabilities.torch) {
          this.isTorchOn = !this.isTorchOn;
          track.applyConstraints({
            advanced: [{ torch: this.isTorchOn }]
          }).then(() => {
            // this.toggleTorchBtn.innerHTML = `<i class="fas ${this.isTorchOn ? 'fa1-bolt' : 'fa1-bolt-close'}"></i> ${this.isTorchOn ? '轻触关闭' : '轻触照亮'}`;
            this.toggleTorchBtn.style.color = this.isTorchOn ? '#FF9900' : '#fff';
          }).catch(console.error);
        } else {
          alert('当前摄像头不支持闪光灯');
        }
      } else {
        alert('当前浏览器不支持闪光灯控制');
      }
    },

    // 切换摄像头
    async switchCamera() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
      }

      this.isBackCamera = !this.isBackCamera;

      try {
        const constraints = {
          video: {
            facingMode: this.isBackCamera ? 'environment' : 'user'
          }
        };

        this.mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
        this.video.srcObject = this.mediaStream;

        // 重置闪光灯状态
        this.isTorchOn = false;
        this.toggleTorchBtn.innerHTML = '<i class="fas fa-bolt"></i> 闪光灯';
        this.toggleTorchBtn.style.color = '#fff';
      } catch (error) {
        console.error('切换摄像头失败:', error);
        alert('切换摄像头失败');
      }
    },

    async uploadImage(url) {
      if (!this.capturedCanvas) {
        // alert('没有可上传的图像');
        return;
      }

      try {
        // 将Canvas转换为Blob
        this.capturedCanvas.toBlob(async (blob) => {
          // 创建FormData
          const formData = new FormData();
          formData.append('file', blob, 'scan_result.jpg');
          formData.append('qr', url);
          formData.append('timestamp', new Date().toISOString())
          // 这里替换为您的服务器端API地址
          // const serverUrl = '/prod-api/system/kHttpCode/common/uploadImage';
          const serverUrl = '/prod-api/system/kHttpCode/common/imageCompareForQR';

          // 发送请求到服务器
          const response = await fetch(serverUrl, {
            method: 'POST',
            body: formData
          });
          this.scanTip = false
          if (response.ok) {
            const result = await response.json()
            console.log('----result-----', result)
            await this.onlineCustomerService(result, url)
            return result
          } else {
            throw new Error('服务器响应错误');
          }
        }, 'image/jpeg', 0.9);
      } catch (error) {
        console.error('上传失败:', error);
      }
    },
    async doUploadImage(canvas) {
      return new Promise((resolve, reject) => {
        // 将Canvas转换为Blob
        canvas.toBlob(async (blob) => {
          // 创建FormData
          const formData = new FormData();
          formData.append('file', blob, 'scan_result.jpg');
          formData.append('scanResult', this.lastScanResult || '未检测到二维码');
          formData.append('timestamp', new Date().toISOString())
          // 这里替换为您的服务器端API地址
          const serverUrl = '/prod-api/system/kHttpCode/common/uploadImage';

          // 发送请求到服务器
          const response = await fetch(serverUrl, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            const result = await response.json()
            resolve(result)
          } else {
            reject(new Error('服务器响应错误'));
          }
        }, 'image/jpeg', 0.9);
      })
    },
    async onlineCustomerService(uploadResult, qr) { //调用人工客服

      let qr_res = await listKHttpCode({ pageNum: 1, pageSize: 1, http: qr })
      let _kHttpCode = qr_res.rows.length > 0 ? qr_res.rows[0] : {}
      let imgSrc = uploadResult.url;
      let qrData = JSON.parse(uploadResult.qr || "{}")
      console.log('qrData : ', qrData)
      let fullPath = imgSrc.includes('http') ? imgSrc : 'https://y3wm.cn' + imgSrc
      let yourWl = uploadResult.qr ? 'https://y3wm.cn' + qrData.cut_img_path : fullPath
      let _data = {
        "status": { "code": "4", "msg": "判真！" },
        "data": {
          "fullPath": fullPath,
          "qr": qr,
          "productName": "柯斯样标Q2",
          "yourWl": [yourWl],
          "myWl": [_kHttpCode.certificateImageUrl.includes('http') ? _kHttpCode.certificateImageUrl : 'https://y3wm.cn' + _kHttpCode.certificateImageUrl],
          "yourQrAndWl": "/group1/M00/A0/2F/Ch-a62kUXd-AWCRZAABn-wu7S3k763.jpg",
          "myQrAndWl": "/group1/M00/A0/2F/Ch-a62kUXd-AUgsfAABBQIntkB0806.jpg",
          "productLogo": "/group1/M00/A0/2F/Ch-a62kUXd-AfFcWAAB_wVa2O1U505.jpg",
          "productImgPath": "/group1/M00/A0/2F/Ch-a62kUXd-AekmmAAGTfbVwV_c596.jpg",
          "rate": 54,
          "type": 0,
          "addrssx": "北京市北京市",
          "adcode": "110100",
          "baseRate": 30,
          "showVideoPath": "",
          "showImgPath": "",
          "showGifPath": "",
          "videoType": "5",
          "qrScanningCount": 187
        }
      };
      if (qr_res.rows.length > 0) {
        if (this.model == 2) {
          let dataUrl = this.capturedCanvas.toDataURL('image/jpeg');
          const img = new Image();
          img.src = dataUrl;
          img.onload = async () => {
            if (this.applet.obj.judgeModel == 3 || this.applet.obj.judgeModel == 4) { //3:人工+自动，4:全自动
              // let result = await this.processComparison(img, qr_res.rows[0].certificateImageUrl.replaceAll('http://doc.ksy7.cn', 'https://www.ksy7.cn'))
              // console.log('processComparison', result)
              console.log(qrData.count)
              if (qrData.count > 10) { //大于20判真，小于20判假
                this.compared(_data, "2")
                setTimeout(() => {
                  this.$store.commit('SET_JudgeResult', '相符')
                }, 500);
                return;
              } else if (this.applet.obj.judgeModel == 4) { //判假后走人工
                this.compared(_data, "2")
                
                setTimeout(() => {
                  // this.$store.commit('SET_JudgeResult', '不相符')
                  this.$store.commit('SET_JudgeResult', '无响应')
                }, 500);
                return;
              }
               else if (this.applet.obj.judgeModel == 3) {
                this.rengong(_data)
                this.compared(_data, "2")
                // this.$store.commit('SET_JudgeResult', '无响应')
                return;
              }
            }else{
               this.rengong(_data)
               this.compared(_data, "2")
            }
          }
        }

        // this.isXWOrWL = 1
        // this.applet.judgeModel = 2
        // console.log('onlineCustomerService')
        // this.applet.obj.judgeModel == 2
        // this.rengong(_data)
        // this.compared(_data, "2")
      }
    },
    rengong(res) {
      var timeCount = this.downTotal;
      var intervalobj = setInterval(() => {
        if (this.fenBu) {//当判定结果返回时停止定时器
          clearInterval(intervalobj);
        }
        console.log(timeCount)
        if (timeCount == 0) {//当判定结果一直没返回时，显示超时
          if (this.applet.obj.judgeModel == 2 || this.applet.obj.judgeModel == 3)
            this.$store.commit('SET_JudgeResult', '无响应')
          clearInterval(intervalobj);
        }
        timeCount--;
        if (this.mimc.mimc_inter) {//当用户登录成功后才进行发送消息
          for (var i = 0; i < this.customerServiceObj.customerServices.length; i++) {//循环发给人工客服
            // console.log(this.customerServiceObj.customerServices)
            this.sendMsg(this.customerServiceObj.customerServices[i].loginName, JSON.stringify(res.data))
          }
          this.mimc.mimc_inter = false;
        }
      }, 1000)
    },
    compared(res, pageType) {
      let _key = new Date().getTime()
      sessionStorage.setItem("KSY_RESULT_" + _key, JSON.stringify(res.data))
      let _page = this.applet.pages.find(item => { return item.pageType == pageType })
      this.$router.push({ path: '/main', query: { pageId: _page.pageId, key: _key, url: this.$route.query.url, appletId: this.$route.query.appletId } })
      this.stopCamera()
    },

    login() {
      this.mimc.user = new MIMCUser(this.mimc.mimc_appId, this.mimc.mimc_appAccount);
      this.mimc.user.registerP2PMsgHandler(this.receiveP2PMsg);//接收单聊消息回调
      this.mimc.user.registerFetchToken(this.fetchMIMCToken);//获取token回调
      this.mimc.user.registerStatusChange(this.statusChange);//登录结果回调
      this.mimc.user.registerServerAckHandler(this.serverAck);//发送消息后，服务器接收到消息ack的回调
      this.mimc.user.registerDisconnHandler(this.disconnect);//连接断开回调
      this.mimc.user.login();
    },
    //小米云通讯
    fetchMIMCToken() {
      let that = this;
      let sendData = { appId: that.mimc.mimc_appId, appKey: that.mimc.mimc_appKey, appSecret: that.mimc.mimc_appSecret, appAccount: that.mimc.mimc_appAccount };
      return that.httpRequest('https://mimc.chat.xiaomi.net/api/account/token', sendData);
    },
    httpRequest: function (url, data) {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, false);
      xhr.setRequestHeader('content-type', 'application/json');
      xhr.send(JSON.stringify(data));
      return JSON.parse(xhr.response);
    },
    receiveP2PMsg(message) {//接收单聊消息回调  //N
      var that = this;
      var date = new Date(parseInt(message.getTimeStamp()));

      var disMsg = Base64;//new Base64();

      var msgData = JSON.parse(disMsg.decode(JSON.parse(message.getPayload()).content));
      var iobj = {
        data: {
          createTime: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds(),
          fullPath: msgData.fullPath,
          myWl: msgData.myWl,
          yourWl: msgData.yourWl,
          myQrAndWl: msgData.myQrAndWl,
          yourQrAndWl: msgData.yourQrAndWl,
          productImgPath: msgData.productImgPath,
          productLogo: msgData.productLogo,
          productName: msgData.productName,
          qr: msgData.qr,
          qrScanningCount: msgData.qrScanningCount,
          description: msgData.des,
          rate: msgData.rate,
          baseRate: msgData.baseRate,
          type: msgData.type
        },
        status: {
          code: msgData.newCode
        }
      }
      that.wenliCode = msgData.newCode;
      that.fenBu = true;
      if (msgData.newCode == 1) {
        that.$store.commit('SET_JudgeResult', '不相符')
      } else if (msgData.newCode == 3) {//真
        that.$store.commit('SET_JudgeResult', '相符')
      } else if (msgData.newCode == 4) {
        that.$store.commit('SET_JudgeResult', '不相符')
      }
    },
    statusChange(bindResult, errType, errReason, errDesc) {//登录结果回调
      var that = this;
      if (bindResult) {
        that.mimc.mimc_inter = true;
        // console.log("login succeed");
      } else {
        console.log("login failed.errReason=" + errReason + ",errDesc=" + errDesc + ",errType=" + errType);
      }
    },

    serverAck(packetId, sequence, timeStamp, errMsg) {//发送消息后，服务器接收到消息ack的回调
      //writeToScreens("receive msg ack:" + packetId + ",sequence=" + sequence + ",ts=" + timeStamp);
      return;
    },
    disconnect() {//连接断开回调
      var that = this;
      that.login();
    },
    logout() {//退出登录
      var that = this;
      that.user.logout();
    },
    sendMsg(toUser, message) {//发送单人消息
      var that = this;

      var a = Base64;//new Base64();
      var message_ = a.encode(message);
      var jsonMsg = String(JSON.stringify({
        version: 0,
        msgId: "TEXT_1234",
        msgType: 103,
        timestamp: String((new Date()).valueOf()),
        payload: message_,
        content: message_
      }));

      try {
        var packetId = that.mimc.user.sendMessage(toUser, jsonMsg);
      } catch (err) {
        console.log("sendMessage fail, err=" + err);
      }
      //that.chats.push(that.mimc_appAccount + " to " + toUser + ":" + message);
    },
  }
}
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.fa1-bolt {
  display: inline-block;
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/轻触照亮.png");

  &::before {
    display: none;
  }
}

.fa1-bolt-close {
  display: inline-block;
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/照亮关闭.png");

  &::before {
    display: none;
  }
}

body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background-color: #000;
  color: #fff;
  overflow: hidden;
  height: 100vh;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
}

.header {
  padding: 15px 20px;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

.header h1 {
  font-size: 18px;
  font-weight: 500;
}

.header button {
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.camera-container {
  flex: 1;
  position: relative;
  overflow: hidden;
}

#video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.scan-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.scan-frame {
  width: 180px;
  height: 180px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  position: relative;
  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.7);
}

.scan-frame:before,
.scan-frame:after,
.scan-frame-inner:before,
.scan-frame-inner:after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border-color: #07C160;
  border-style: solid;
  border-width: 0;
}

.scan-frame:before {
  top: 0;
  left: 0;
  border-top-width: 3px;
  border-left-width: 3px;
}

.scan-frame:after {
  top: 0;
  right: 0;
  border-top-width: 3px;
  border-right-width: 3px;
}

.scan-frame-inner:before {
  bottom: 0;
  left: 0;
  border-bottom-width: 3px;
  border-left-width: 3px;
}

.scan-frame-inner:after {
  bottom: 0;
  right: 0;
  border-bottom-width: 3px;
  border-right-width: 3px;
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(to right, transparent, #07C160, transparent);
  animation: scan 2s linear infinite;
  box-shadow: 0 0 10px rgba(7, 193, 96, 0.7);
}

@keyframes scan {
  0% {
    top: 0;
  }

  100% {
    top: 100%;
  }
}

.scan-tips {
  margin-top: 30px;
  text-align: center;
  padding: 0 20px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}

.status-panel {
  position: absolute;
  bottom: 120px;
  left: 0;
  width: 100%;
  padding: 15px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  margin: 0 15px;
  display: none;
}

.status-panel.show {
  display: block;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.clarity-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.clarity-icon {
  margin-right: 10px;
  font-size: 20px;
}

.clarity-text {
  flex: 1;
}

.clarity-value {
  font-weight: bold;
  margin-left: 10px;
}

.clarity-good {
  color: #07C160;
}

.clarity-average {
  color: #FF9900;
}

.clarity-poor {
  color: #FF0000;
}

.clarity-suggestions {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 8px;
}

.action-bar {
  display: flex;
  justify-content: space-around;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.9);
}

.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
  border: none;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.action-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.action-btn i {
  font-size: 24px;
  margin-bottom: 8px;
}

.result-panel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 100;
  display: none;
}

.result-panel.show {
  display: flex;
}

.result-content {
  background-color: #1a1a1a;
  border-radius: 15px;
  padding: 25px;
  max-width: 90%;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.result-icon {
  font-size: 60px;
  margin-bottom: 20px;
  color: #07C160;
}

.result-text {
  font-size: 16px;
  margin-bottom: 20px;
  word-break: break-all;
}

.result-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.result-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  background-color: #07C160;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.result-btn:hover {
  opacity: 0.9;
}

.result-btn.secondary {
  background-color: #333;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #fff;
  z-index: 5;
}

@media (max-width: 480px) {
  .scan-frame {
    width: 180px;
    height: 180px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/scanQR/identify2.vue